import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button } from '@mui/material';
import SimpleDialog from 'core/components/Dialogs/SimpleDialog';
import { isNil, gt } from 'lodash';
import { OrderDiscountTypeEnum } from 'models/enums/orderDiscountTypeEnum';
import { useEffect, useState } from 'react';
import {
  FormContainer,
  TextFieldElement,
  TextareaAutosizeElement,
  useForm,
} from 'react-hook-form-mui';
import { number, object, string } from 'yup';
import type { OrderDiscountInfo } from 'models/order/orderDiscountInfo';
import type { FC } from 'react';
import type { Schema } from 'yup';
interface FormData extends Pick<OrderDiscountInfo, /* 'type' | */ 'sum'> {
  remark?: string | null;
}

const schema: Schema<FormData> = object().shape({
  remark: string().max(1000).notRequired(),
  // type: number().oneOf(enum2NumberArray(OrderDiscountTypeEnum)).required(),
  sum: number()
    .required()
    .min(0)
    .test('max-value', 'Процентная скидка не может быть больше 100%', function (value) {
      const { type } = this.parent;
      if (type === OrderDiscountTypeEnum.Percentage) {
        return value <= 100;
      }
      return value <= 1_000_000_000;
    }),
});

const DiscountEditDialog: FC<DiscountEditDialogProps> = ({
  discount,
  open,
  onCancel,
  onSave,
}) => {
  const formContext = useForm<FormData>({
    resolver: yupResolver(schema),
  });

  const [saving, setSaving] = useState(false);
  // const watchedType = formContext.watch('type');

  useEffect(() => {
    formContext.reset(discount);
  }, [formContext, discount]);

  const handleOnSave: VoidFunction = () => {
    const editedDiscount = {
      ...discount,
      ...formContext.getValues(),
      remark: formContext.getValues('remark') ?? '',
    };

    if (!isNil(onSave)) {
      setSaving(true);
      onSave(editedDiscount)
        .finally(() => {
          setSaving(false);
        })
        .catch(console.log);
    }
  };

  const getTitle = (): string =>
    gt(discount.id, 0) ? 'Редактирование скидки' : 'Новая скидка';

  const getSumLabel = (): string =>
    // if (watchedType === OrderDiscountTypeEnum.Percentage) {
    //   return 'Размер скидки (%)';
    // }
    'Размер скидки (₽)';
  return (
    <SimpleDialog
      title={getTitle()}
      open={open}
      onClose={onCancel}
      actions={
        <>
          <LoadingButton
            loading={saving}
            onClick={() => {
              void formContext.handleSubmit(handleOnSave)();
            }}>
            <span>Сохранить</span>
          </LoadingButton>
          <Button onClick={onCancel}>Закрыть</Button>
        </>
      }
      content={
        <FormContainer formContext={formContext} onSuccess={handleOnSave}>
          {/* <SelectElement
            label='Тип скидки'
            name='type'
            margin='normal'
            fullWidth
            required
            options={enum2NumberArray(OrderDiscountTypeEnum).map((v) => ({
              id: v,
              label: getOrderDiscountTypeName(v),
            }))}
          /> */}

          <TextFieldElement
            fullWidth
            label={getSumLabel()}
            name='sum'
            type='number'
            margin='normal'
            required
            inputProps={{
              min: 0,
              max: /* watchedType === OrderDiscountTypeEnum.Percentage ? 100 : */ 900_000_000,
              step: /* watchedType === OrderDiscountTypeEnum.Percentage ? 0.01 : */ 1,
            }}
          />

          <TextareaAutosizeElement
            fullWidth
            label='Примечание'
            name='remark'
            margin='normal'
            resizeStyle='vertical'
            rows={2}
          />
        </FormContainer>
      }
    />
  );
};

export interface DiscountEditDialogProps {
  discount: OrderDiscountInfo;
  open: boolean;
  onSave?: (discount: OrderDiscountInfo) => Promise<boolean>;
  onCancel?: VoidFunction;
}

export default DiscountEditDialog;
